import {API_BASE, EDITOR_API} from "../util/config";

const json = async (res) => {
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
};

const downloadBlob = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    return blob;
};

const postForBlob = async (path, formData) => {
    const res = await fetch(`${API_BASE}${path}`, { method: "POST", body: formData });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.blob();
};

// PDF processing — wraps existing backend endpoints
export const pdfApi = {
    merge: async (files, filename = "merged-document.pdf") => {
        const formData = new FormData();
        files.forEach((file) => formData.append("files", file));
        const blob = await postForBlob("/api/pdf/merge", formData);
        return downloadBlob(blob, filename);
    },

    imageToPdf: async (imageFile) => {
        const formData = new FormData();
        formData.append("file", imageFile);
        const blob = await postForBlob("/api/pdf/image/convert-image", formData);
        const outName = `${imageFile.name.replace(/\.[^/.]+$/, "")}.pdf`;
        return downloadBlob(blob, outName);
    },

    compress: async (pdfFile, pdfQuality) => {
        const formData = new FormData();
        formData.append("file", pdfFile);
        formData.append("pdfQuality", pdfQuality);
        const blob = await postForBlob("/api/pdf/compress/compress-pdf", formData);
        return downloadBlob(blob, `compressed-${pdfFile.name}`);
    },
};

// Stats
export const statsApi = {
    summary: () => fetch(`${API_BASE}/api/stats/summary`).then(json),
    logExport: (toolId, fileSizeBytes) => {
        return fetch(`${API_BASE}/api/stats/log`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ toolId, fileSizeBytes }),
        }).catch((e) => console.warn("Stats log failed (non-fatal):", e));
    },
};

// Comments
export const commentsApi = {
    list: () => fetch(`${API_BASE}/api/comments`).then(json),
    create: (authorName, toolId, body) =>
        fetch(`${API_BASE}/api/comments`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ authorName, toolId, body }),
        }).then(json),
    board: () => fetch(`${API_BASE}/api/comments/board`).then(json),
    updateStatus: (id, status) =>
        fetch(`${API_BASE}/api/comments/${id}/status`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ status }),
        }).then(json),
};

export const pdfEditApi = {
    upload: async (file) => {
        const fd = new FormData();
        fd.append("file", file);
        const res = await fetch(`${EDITOR_API}/upload`, { method: "POST", body: fd });
        if (!res.ok) throw new Error(`Upload failed: HTTP ${res.status}`);
        return res.json();
    },

    getPage: (sessionId, pageNum) =>
        fetch(`${EDITOR_API}/page/${sessionId}/${pageNum}`).then(json),

    edit: (payload) =>
        fetch(`${EDITOR_API}/edit`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        }).then(json),

    download: async (sessionId, filename = "edited.pdf") => {
        const res = await fetch(`${EDITOR_API}/download/${sessionId}`);
        if (!res.ok) throw new Error(`Download failed: HTTP ${res.status}`);
        const blob = await res.blob();
        return downloadBlob(blob, filename);
    },
};